import format from 'date-fns/format';

export const formatStrategyPrice = price => `$${price ? price.toLocaleString().replace('.', ',') : 0}`;

export const formatPaymentTime = time => format(new Date(time._seconds * 1000), 'D MMMM YYYY, HH:MM');

export const strategyPrice = price => (price !== 0 ? `${Number(price).toFixed(2)}$` : 'Free');
